module.exports = __webpack_public_path__ + "static/3-9a53f3f91acff13a9d368599b70a9f63.jpeg";